import React from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      id="footer"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        height: "auto", // Adjust height to fit content
        width: "100%",
        backgroundColor: "background.paper",
        color: "text.primary",
        padding: { xs: 1, sm: 2 }, // Adjust padding based on screen size
        boxShadow: 3,
        zIndex: 1000,
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack links vertically on small screens
          justifyContent: "space-between",
          alignItems: "center",
          gap: { xs: 1, sm: 0 }, // Add spacing between items on mobile
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ textAlign: { xs: "center", sm: "left" } }}
        >
          {t("footer.copyright", { year: currentYear })}
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "row", sm: "row" },
            gap: 2,
            justifyContent: "center",
          }}
        >
          <Link
            href="https://musicrandomizer.com/"
            target="_blank"
            color="inherit"
            sx={{ textAlign: "center" }}
          >
            MusicRandomizer
          </Link>
          <Link
            href="https://MusicTierList.com/"
            target="_blank"
            color="inherit"
            sx={{ textAlign: "center" }}
          >
            MusicTierList
          </Link>

          <Link
            href="https://MusicBrackets.com/"
            target="_blank"
            color="inherit"
            sx={{ textAlign: "center" }}
          >
            MusicBrackets
          </Link>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "row", sm: "row" },
            gap: 2,
            justifyContent: "center",
          }}
        >
          <Link href="/Policies/PrivacyPolicy" color="inherit" sx={{ textAlign: "center" }}>
            {t("footer.privacy")}
          </Link>
          <Link href="/CookiePolicy" color="inherit" sx={{ textAlign: "center" }}>
            {t("footer.cookies")}
          </Link>
          <Link
            href="https://x.com/musicrandomized"
            target="_blank"
            color="inherit"
            sx={{ textAlign: "center" }}
          >
            {t("footer.twitter")}
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
